import React from 'react'
import { connectCurrentRefinements } from 'react-instantsearch-dom'
// 1. Create a React component
const ClearRefinements = (props) => (
    <button className="d-none" ref={props.buttonRef} onClick={() => props.refine(props.items)}>
    </button>
)
// 2. Connect the component using the connector
export default connectCurrentRefinements(ClearRefinements)
